import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/contenzi.webp';
import screenshot_target from '../../../images/letterfunnel/tomassalfischberger.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Tomas Salfischberger"
      firstname="Tomas"
      companyname="Contenzi"
      competition="Ninetailed en Nosto"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/tomassalfischberger.js